<template>
    <div class="loading">
        <!-- <stretch :background="color" :size="width"></stretch> -->
        <vue-loading type="spiningDubbles" color="#364983" :size="{ width: width, height: width }"></vue-loading> 
    </div>
</template>
<script>
    import VueLoading from 'vue-loading-template'
    export default {
         components:{
             VueLoading
         },
         props:{
            color:{
                type: String,
                default: '#364983'
            },
            width:{
                type: String,
                default: '60px'
            }
         },
         data: function() {
             return {

             }
         },
         created: function() {

         }
    }
</script>
<style lang="scss" scoped>
    .loading{
        margin: 0 auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/loading/loading.vue